require('../js/imagesloaded.min');
require('../js/scripts');
require('../js/event-registeration');
//require('slick-carousel')
require('../sass/style.scss');